import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { NzModalModule, NzModalService } from "ng-zorro-antd/modal";
import { PhonePipe } from "./pipes/phone.pipe";
import { SafePipe } from "./pipes/SafePipe.pipe";
import { NzTableModule } from "ng-zorro-antd/table";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzSelectModule } from "ng-zorro-antd/select";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzDropDownModule } from "ng-zorro-antd/dropdown";
import { NzTabsModule } from "ng-zorro-antd/tabs";
import { NzPopconfirmModule } from "ng-zorro-antd/popconfirm";
import { NzSpaceModule } from "ng-zorro-antd/space";
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzDescriptionsModule } from "ng-zorro-antd/descriptions";
import { NzAvatarModule } from "ng-zorro-antd/avatar";
import { NzListModule } from "ng-zorro-antd/list";
import { NzCardModule } from "ng-zorro-antd/card";
import { NzFormModule } from "ng-zorro-antd/form";
import { NzCheckboxModule } from "ng-zorro-antd/checkbox";
import { NzDatePickerModule } from "ng-zorro-antd/date-picker";
@NgModule({
  declarations: [SafePipe, PhonePipe],
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SafePipe,
    PhonePipe,
    NzTableModule,
    NzButtonModule,
    NzIconModule,
    NzSelectModule,
    NzInputModule,
    NzTagModule,
    NzSkeletonModule,
    NzModalModule,
    NzDropDownModule,
    NzTabsModule,
    NzPopconfirmModule,
    NzSpaceModule,
    NzBadgeModule,
    NzDescriptionsModule,
    NzAvatarModule,
    NzListModule,
    NzCardModule, 
    NzFormModule,
    NzCheckboxModule,
    NzDatePickerModule
  ],
  providers: [NzModalService],
})
export class SharedModule {}
